module.exports = [
    // { propName: 'aria-role', dataName: 'ariaRole' }
]
